import { Button, Form } from 'antd'
import { NamePath } from 'antd/es/form/interface'
import { FC } from 'react'
import { DeleteOutlined } from '@ant-design/icons'

interface MaterialRemoveProps {
    name: NamePath
    remove: (index: number | number[]) => void
    disabled?: boolean
}

const MaterialRemove: FC<MaterialRemoveProps> = ({ name, remove, disabled }) => {
    return (
        <Form.Item label={' '}>
            <Button
                icon={<DeleteOutlined />}
                danger
                onClick={() => remove(name)}
                disabled={disabled}
            />
        </Form.Item>
    )
}

export default MaterialRemove
